module.exports = __webpack_public_path__ + "img/man-lay.3dc35801.png";